
    <h1 mat-dialog-title class="text-center mb-4 text-danger">Warning: Percentage is too high</h1>
    <div class="d-flex flex-column align-items-center">
      <p class="text-center mb-4">
      Notice: This job may have exterior/ total leakage numbers that are failing. Please check the testing tab to ensure the leakage numbers are in range, and re-test if not.
      </p>
      <button mat-button color="primary" (click)="dialogRef.close()">OK</button>
    </div>
  